import React from 'react';
import { makeStyles } from '@mui/styles';
import BasicButton from '../@common/Buttons/BasicButton';
import { remCalc } from '../../util/style-util';
import { ltGrey, black } from '../../styles/style-constants';
import { ComponentType } from 'react';
import { FONT_GSS_PRINT_WIDE } from 'themes/default';

type Props = {
  isActive: boolean;
  name: string;
  icon?: ComponentType<any>;
  iconSize?: string | number;
} & any;

const MenuGroupButton = ({ isActive, name, icon: Icon, iconSize, ...props }: Props) => {
  const { menuGroupButton, activeButton } = useStyles();
  return (
    <BasicButton
      buttonStyles={[menuGroupButton, isActive && activeButton ? activeButton : '']}
      {...props}
    >
      {Icon ? <Icon width={iconSize && remCalc(iconSize)} /> : name}
    </BasicButton>
  );
};

const useStyles = makeStyles(() => {
  return {
    menuGroupButton: {
      color: ltGrey,
      fill: ltGrey,
      fontFamily: `${FONT_GSS_PRINT_WIDE} !important`,
      fontSize: `${remCalc(22)} !important`,
      minWidth: remCalc(40),
      maxHeight: remCalc(52),
      margin: remCalc(0, 14),
      '&:hover': {
        color: black,
        fill: black
      },
      transition: 'color 150ms, fill 150ms'
    },
    activeButton: {
      color: black,
      fill: black
    }
  };
});

export default MenuGroupButton;
